import React from 'react'
import { Button, Flowbite, TextInput, Timeline } from 'flowbite-react';
import { timeLineTheme } from './themes';
import {BiCurrentLocation} from 'react-icons/bi'
import {MdLocationOn} from 'react-icons/md'

export default function  RideCard(props) {
    const rideDetails = props.rideDetails;
  return (
    <div className='!gap-4 !p-[40px] max-w-[600px] min-w-[400px] box-container'>
        <h2>RexRide Details</h2>
   
        <Flowbite theme={{theme:timeLineTheme}}>
            <Timeline>
                <Timeline.Item>
                    <Timeline.Point icon={BiCurrentLocation}/>
                    <Timeline.Content>
                        <Timeline.Time>
                            Start Location  
                        </Timeline.Time>
                        <Timeline.Title>
                            {rideDetails?.departure}
                        </Timeline.Title>
                    </Timeline.Content>
                </Timeline.Item>
                <Timeline.Item>
                    <Timeline.Point icon={MdLocationOn}/>
                    <Timeline.Content>
                        <Timeline.Time>
                            Destination
                        </Timeline.Time>
                        <Timeline.Title>
                            {rideDetails?.destination}
                        </Timeline.Title>
                    </Timeline.Content>
                </Timeline.Item>
            </Timeline>
        </Flowbite>
        <div className='flex justify-between'>
            <div>
                <p className='font-bold text-gray-900 text-sm'>Date & Time</p>
                <p>{new Date(rideDetails?.date.seconds * 1000).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}{" "}{rideDetails?.time}</p>
            </div>
            <div>
                <p className='font-bold text-gray-900 text-sm'>Price</p>
                <p>${rideDetails?.price}</p>
            </div>
            <div>
                <p className='font-bold text-gray-900 text-sm'>Seats</p>
                <p>{rideDetails?.seats - rideDetails?.passengers.length}{"/"}{rideDetails?.seats}</p>
            </div>
        </div>
    </div>
  )
}
    